import React, {memo} from 'react';
import Typography from '@material-ui/core/Typography';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import EntityFilePicker from './EntityFilePicker';
import {actionCreators as selfServiceActionCreators} from '../redux/actions/selfServiceActions';
import {downloadDocument, convertBufferedMessageToString} from '../shared/documentUtil';
import Button from '@material-ui/core/Button';
import {useDispatch} from 'react-redux';
import {useParams} from 'react-router-dom';

const DynamicFileControl = (props) => {
	const field = props.field;
	const selfServiceDocuments = field.SelfServiceDocuments;
	const inscopeDocuments = field.InScopeDocuments;
	const fieldError = props.fieldError;
	const setFieldError = props.setFieldError;
	const dispatch = useDispatch();
	const allParams = useParams();

	const buttonsStyle = {
		fontSize: '11px',
		margin: '5px',
	};

	const downloadDocumentTypeTemplate = async () => {
		var entityChangeRequestID = allParams.entityId;
		var documentTypeID  = field.DocumentTypeID;
		setFieldError(null);
		const response = await dispatch(
			selfServiceActionCreators.downloadDocumentTypeTemplate(entityChangeRequestID,documentTypeID)
		);

		if(response.requestError) {
			setFieldError(convertBufferedMessageToString(response.requestError.response.data));
		}
		else {
			downloadDocument(response);
		}
	};

	return (
		<>
			<FormGroup className='entity-document-field'>
				<fieldset className='entity-fieldset'>
					<Typography component='legend' color='primary'>
						<legend>
							{field.IsMandatory ? '*' : ''}
							{field.FieldName}
						</legend>
					</Typography>
					{
						fieldError ?
						<Typography variant="body2" color="error">
							{fieldError }
						</Typography>
						: ""
					}
					<p dangerouslySetInnerHTML={{ __html: field.HelpText }}></p>
					
					{ field.HasTemplate ?
						<>
						{field.TemplateHelpText ? <p>{field.TemplateHelpText}</p>: <></>}
						<Button
							style={{...buttonsStyle}}
							variant='contained'
							color='primary'
							size='small'
							onClick={downloadDocumentTypeTemplate}
							disabled={!field.HasTemplate}
							startIcon={<CloudDownloadIcon />}>
							Download Template
						</Button>
						</>
						:<> </>
					}

					<Grid container>
						<Grid
							item
							style={{
								marginTop: 'auto',
								marginBottom: 'auto',
								textAlign: 'center',
								width: '100%',
							}}
						>
							{
								inscopeDocuments && inscopeDocuments.length !== 0 ? 
								<FormGroup className='entity-document-field'>
									<fieldset className='entity-fieldset'>
										<Typography component='legend' color='primary'>
											<legend>Documents Available On File</legend>
										</Typography>

										{inscopeDocuments.map((document) => (
											<EntityFilePicker
												key={document.BaseDocumentId}
												field={field}
												setFieldError={setFieldError} 
												document={document}
											/>
										))}
									</fieldset>
								</FormGroup>: <></>
							}
							<FormGroup className='entity-document-field'>
								<fieldset className='entity-fieldset'>
									<Typography component='legend' color='primary'>
										<legend>Uploaded Documents</legend>
									</Typography>
									{selfServiceDocuments.map((document) => (
										<EntityFilePicker
											key={document.BaseDocumentId}
											field={field}
											setFieldError={setFieldError} 
											document={document}
										/>
									))}
									<EntityFilePicker
										key={`new-document`}
										field={field}
										setFieldError={setFieldError} 
										addingMode={true}
									/>
								</fieldset>
							</FormGroup>
						</Grid>
					</Grid>
				</fieldset>
			</FormGroup>
		</>
	);
};
export default memo(DynamicFileControl);
